import devdocs from "../../../../assets/img/programming/devdocs.webp";
import mdn from "../../../../assets/img/programming/mdn.webp";
import zeal from "../../../../assets/img/programming/zeal.webp";
import w3schools from "../../../../assets/img/programming/w3schools.webp";
import devhints from "../../../../assets/img/programming/devhints.webp";
import overapi from "../../../../assets/img/programming/overapi.webp";
import devto from "../../../../assets/img/programming/devto.webp";
import javascripting from "../../../../assets/img/programming/javascripting.webp";
import cheatography from "../../../../assets/img/programming/cheatography.webp";

export const DataDoc = [
  {
    title: "DevDocs",
    path: "https://devdocs.io/javascript/",
    icon: devdocs,
    cName: "icon",
    description:
      "DevDocs combines multiple API documentations in a fast, organized, and searchable interface. It can be used Offline.",
  },
  {
    title: "MDN",
    path: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
    icon: mdn,
    cName: "icon",
    description:
      "MDN Web Docs (previously known as MDN — the Mozilla Developer Network) is an evolving learning platform for Web technologies and the software that powers the Web.",
  },
  {
    title: "Zeal",
    path: "https://zealdocs.org/",
    icon: zeal,
    cName: "icon",
    description:
      "Zeal is an offline documentation browser for software developers. Zeal comes with 200 awesome docsets.",
  },
  {
    title: "W3schools",
    path: "https://www.w3schools.com/js/default.asp",
    icon: w3schools,
    cName: "icon",
    description:
      "W3Schools is an educational website for learning web technologies online. Content includes tutorials and references.",
  },
  {
    title: "Devhints",
    path: "https://devhints.io/jsdoc",
    icon: devhints,
    cName: "icon",
    description: "This is a collection of cheatsheets. Thanks to Rico.",
  },
  {
    title: "Html-css-js",
    path: "https://html-css-js.com/js/",
    icon: devto,
    cName: "icon",
    description:
      "HTML, CSS and JS are the parts of all websites that users directly interact with. Maximize your coding efficiency and provide the best user experience with our free online tool collection!",
  },
  {
    title: "OverAPI",
    path: "https://overapi.com/javascript",
    icon: overapi,
    cName: "icon",
    description: "Collecting All Cheat Sheets. Big cheatsheets ressources.",
  },
  {
    title: "Cheatography",
    path: "https://cheatography.com/tag/javascript/",
    icon: cheatography,
    cName: "icon",
    description:
      "Over 3,500 Free Cheat Sheets, Revision Aids and Quick References. You can create yours.",
  },
];

export const DataLibrary = [
  {
    title: "JavaScripting",
    path: "https://www.javascripting.com/",
    icon: javascripting,
    cName: "icon",
    description:
      "The definitive source of the best JavaScript libraries, frameworks, and plugins.",
  },
];
